import { CgBorderStyleDotted } from "react-icons/cg";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import Box from "../box/Box";
import TextComponent from "../textComponent/TextComponent";
import styles from "./steps.module.css";

const Steps = ({ stepLinks, currentStep, setCurrentStep, stepperClass }) => {
  let comp = stepLinks?.find((link) => link.id === currentStep);
  const { height, width } = useWindowDimensions();
  return (
    <div className={styles.stepContainer}>
      <div className={`${styles.boxButtonContainer} ${stepperClass}`}>
        {stepLinks?.map((link, i) => (
          <>
            <Box
              onClick={() =>currentStep > link.id && setCurrentStep(link.id)}
              boxClass={`${styles.boxButton} ${
                link?.id <= currentStep ? styles.solid : styles.outline
              }`}
            >
              <TextComponent>{i + 1}</TextComponent>
            </Box>
            {i !== stepLinks?.length - 1 && (
              <>
                {width > 576 ? (
                  [1, 2, 3, 4].map(() => (
                    <CgBorderStyleDotted
                      fontSize={"1.7rem"}
                      style={{
                        margin: "0 -1.4px",
                        color: "#000",
                        opacity: 0.5,
                      }}
                    />
                  ))
                ) : (
                  <CgBorderStyleDotted />
                )}
              </>
            )}
          </>
        ))}
      </div>
      {comp?.component}
    </div>
  );
};

export default Steps;
